import { Patient } from '../contacts/patient.model';
import { StringUtils } from '../shared/utils/string-utils';
import { ContactInformation } from './model/contact-information';

/** System-generated patient self-contact (same `fromEpic` flag as callback location sync). */
export function buildStandalonePatientSelfContact(patient: Patient): ContactInformation | null {
  const contactNumber = patientPhoneToE164(patient.phone);
  if (!contactNumber || !patient.id || !patient.name?.trim()) {
    return null;
  }

  return {
    entityId: patient.id,
    name: patient.name.trim(),
    emergencyContactName: patient.name.trim(),
    contactNumber,
    createdOn: Date.now(),
    isPatient: true,
    fromEpic: true,
    selfPatient: true,
  };
}

export function patientPhoneToE164(phone: string | undefined): string | null {
  if (!phone?.trim()) {
    return null;
  }

  let digits = StringUtils.stripNonDigits(phone);
  if (digits.length === 11 && digits.startsWith('1')) {
    digits = digits.substring(1);
  }
  if (digits.length !== 10) {
    return null;
  }

  return `+1${digits}`;
}
